module.exports = new __parcel__URL__("legendary_asteroid.4ca84886.png").toString();